import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { jobsAPI } from '../utils/api';
import JobCard from '../components/jobs/JobCard';
import './ListingPage.css';

const JOB_TYPES = [
  { value: '', label: 'كل الأنواع' },
  { value: 'full_time', label: 'دوام كامل' },
  { value: 'part_time', label: 'دوام جزئي' },
  { value: 'contract', label: 'عقد' },
  { value: 'freelance', label: 'عمل حر' },
  { value: 'internship', label: 'تدريب' },
];

const JobsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);

  const [filters, setFilters] = useState({
    search: searchParams.get('search') || '',
    job_type: searchParams.get('job_type') || '',
    sport_category: searchParams.get('sport_category') || '',
    is_remote: searchParams.get('is_remote') || '',
    sort: 'newest',
    page: 1,
  });

  useEffect(() => {
    setFilters(prev => ({ page: 1,
      ...prev,
      job_type: searchParams.get("job_type") || "",
      is_remote: searchParams.get("is_remote") || "",
      sport_category: searchParams.get("sport_category") || "",
      search: searchParams.get("search") || "",
    }));
  }, [searchParams]);

  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const params = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v !== ''));
      const res = await jobsAPI.getJobs(params);
      setJobs(res.data.jobs || []);
      setTotal(res.data.total || 0);
      setPages(res.data.pages || 1);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => { fetchJobs(); }, [fetchJobs]);

  const handleFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value, page: key === 'page' ? value : 1 }));
  };

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="page-header">
          <h1>الوظائف الرياضية</h1>
          <p>اكتشف {total} وظيفة في القطاع الرياضي</p>
        </div>

        {/* Filters */}
        <div className="filter-bar">
          <div className="form-group">
            <label className="form-label">بحث</label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-dim)' }}>🔍</span>
              <input
                type="text"
                className="form-input"
                style={{ paddingRight: 40 }}
                placeholder="عنوان الوظيفة، المؤسسة..."
                value={filters.search}
                onChange={e => handleFilter('search', e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">نوع العمل</label>
            <select className="form-select" value={filters.job_type} onChange={e => handleFilter('job_type', e.target.value)}>
              {JOB_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">الرياضة</label>
            <input type="text" className="form-input" placeholder="كرة القدم، سباحة..." value={filters.sport_category} onChange={e => handleFilter('sport_category', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">الترتيب</label>
            <select className="form-select" value={filters.sort} onChange={e => handleFilter('sort', e.target.value)}>
              <option value="newest">الأحدث أولاً</option>
              <option value="oldest">الأقدم أولاً</option>
              <option value="salary_high">الراتب الأعلى</option>
            </select>
          </div>
          <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 0 }}>
              <input type="checkbox" checked={filters.is_remote === 'true'} onChange={e => handleFilter('is_remote', e.target.checked ? 'true' : '')} style={{ accentColor: 'var(--primary)', width: 16, height: 16 }} />
              <span className="form-label" style={{ margin: 0 }}>عن بُعد فقط 🌐</span>
            </label>
          </div>
        </div>

        {loading ? (
          <div className="loading-screen"><div className="spinner" /></div>
        ) : jobs.length === 0 ? (
          <div className="empty-state">
            <div className="icon">💼</div>
            <h3>لا توجد وظائف</h3>
            <p>جرّب تعديل الفلاتر أو البحث بكلمات مختلفة.</p>
          </div>
        ) : (
          <>
            <div className="results-count">{total} وظيفة</div>
            <div className="grid-3">
              {jobs.map(job => <JobCard key={job.uuid} job={job} />)}
            </div>
            {pages > 1 && (
              <div className="pagination">
                <button className="page-btn" onClick={() => handleFilter('page', Math.max(1, filters.page - 1))} disabled={filters.page === 1}>‹</button>
                {Array.from({ length: Math.min(5, pages) }, (_, i) => Math.max(1, Math.min(filters.page - 2, pages - 4)) + i).map(p => (
                  <button key={p} className={`page-btn ${filters.page === p ? 'active' : ''}`} onClick={() => handleFilter('page', p)}>{p}</button>
                ))}
                <button className="page-btn" onClick={() => handleFilter('page', Math.min(pages, filters.page + 1))} disabled={filters.page === pages}>›</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default JobsPage;
